import React from 'react';
import { connect } from 'react-redux';
import Datagrid from '../../../../UI/Datagrid';
// import moment from 'moment';
import { formatData } from './helpers';

function Details(props) {
  function getFirstColText() {
    switch (props.groupHours) {
      case '1':
        return 'Hour';
      case '24':
        return 'Day';
      case '168':
        return 'Week';
      default:
        return 'Month';
    }
  }
  const columns = [
    {
      dataField: 'timeStamp',
      text: getFirstColText(),
      sort: true,
      isDateTime: true,
    },
    {
      dataField: 'avgValue',
      text: 'Avg Value',
      sort: true,
      formatter: (cell, row) => `${row.avgValue} ${row.units}`,
    },
    {
      dataField: 'minValue',
      text: 'Min Value',
      sort: true,
      formatter: (cell, row) => `${row.minValue} ${row.units}`,
    },
    {
      dataField: 'timeStampMin',
      text: 'Min Time',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
    },
    {
      dataField: 'maxValue',
      text: 'Max Value',
      sort: true,
      formatter: (cell, row) => `${row.maxValue} ${row.units}`,
    },
    {
      dataField: 'timeStampMax',
      text: 'Max Time',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
    },
    {
      dataField: 'sum',
      text: 'Total',
      sort: true,
      formatter: (cell, row) => `${row.sum} ${row.unitsTotal}`,
    },
  ];
  const defaultSorted = [
    {
      dataField: 'day',
      order: 'desc',
    },
  ];
  // function dateFormatter(cell) {
  //   return moment(cell, 'YYYY-MM-DDTHH:mm:ssZ').format('MM/DD/YYYY HH:mm:ss');
  // }
  return (
    <div>
      <Datagrid
        datagridProps={{
          keyField: 'timeStamp',
          data: formatData(props.report.statisticsDetails, false),
          loading: props.report.isFetching,
          columns,
          defaultSorted,
        }}
        exportProps={{
          fileName: 'StatisticsDetail-Details',
        }}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    report: state.report,
  };
}

export default connect(mapStateToProps, null)(Details);
